@switch (item.value.type) {
  @case ('all') {
    <rt-dropdown-item [highlighted]="highlighted">
      <rt-icon prefix name="mail-outline" />
      <rt-truncate>{{ item.label }}</rt-truncate>
    </rt-dropdown-item>
  }

  @case ('personal') {
    <rt-dropdown-item [highlighted]="highlighted">
      <rt-avatar
        prefix
        context="admin"
        [size]="'small-x'"
        [type]="item.value.provider.references[0].hasAvatar ? 'image' : 'initials'"
        [imageSrc]="item.value.provider.references[0].photoThumbUrl"
        [initials]="item.value.provider.references[0].initials"
      />
      <rt-truncate>{{ item.value.provider.email }}</rt-truncate>
    </rt-dropdown-item>
  }

  @case ('shared_email_provider') {
    <rt-dropdown-item [highlighted]="highlighted">
      @if ($any(item).value.provider.connectionStatus === 'connected') {
        <rt-icon prefix name="account-group" />
      } @else {
        <rt-icon prefix name="link-off" />
      }
      <rt-truncate class="shared-email-provider-label">{{ item.label }}</rt-truncate>
      <rt-visibility-avatars-list
        suffix
        [users]="users"
        [visibility]="$any(item).value.provider.visibility"
        [moreTitle]="'Mailbox shared with:'"
      />
    </rt-dropdown-item>
  }

  @case ('admin_performing_action') {
    <rt-dropdown-item [highlighted]="highlighted">
      <rt-icon prefix name="person" />
      <rt-truncate>{{ item.label }}</rt-truncate>
    </rt-dropdown-item>
  }

  @case ('recruiter') {
    <rt-dropdown-item [highlighted]="highlighted">
      <div layout-horizontal layout-centered-y>
        <rt-icon name="person-outline" margin-right-small-x />
        <rt-truncate>{{ item.label }}</rt-truncate>
        @if (item.badge) {
          <rt-badge
            [iconName]="item.badge.icon"
            [color]="item.badge.color"
            [text]="item.badge.label"
            [rtTooltip]="item.badge.tooltip"
            [rtTooltipPosition]="'right'"
            margin-left-small-x
          />
        }
      </div>
    </rt-dropdown-item>
  }

  @case ('hiring_manager') {
    <rt-dropdown-item [highlighted]="highlighted">
      <div layout-horizontal layout-centered-y>
        <rt-icon name="person-outline" margin-right-small-x />
        <rt-truncate>{{ item.label }}</rt-truncate>
        @if (item.badge) {
          <rt-badge
            [iconName]="item.badge.icon"
            [color]="item.badge.color"
            [text]="item.badge.label"
            [rtTooltip]="item.badge.tooltip"
            [rtTooltipPosition]="'right'"
            margin-left-small-x
          />
        }
      </div>
    </rt-dropdown-item>
  }

  @case ('admin') {
    <rt-dropdown-item
      [highlighted]="highlighted"
      [rtTooltip]="item.disabledTooltip"
      [rtTooltipPosition]="'right'"
      (click)="!!item.disabled && $event.stopPropagation()"
      [class.item-disabled]="!!item.disabled"
    >
      <rt-avatar
        prefix
        context="admin"
        [size]="'small-x'"
        [type]="$any(item).value.user.hasAvatar ? 'image' : 'initials'"
        [imageSrc]="$any(item).value.user.photoThumbUrl"
        [initials]="$any(item).value.user.initials"
      />
      <rt-truncate>{{ $any(item).label }}</rt-truncate>
    </rt-dropdown-item>
  }

  @default {
    <rt-dropdown-item [highlighted]="highlighted">
      <pre>{{ item | json }}</pre>
    </rt-dropdown-item>
  }
}
